export default{

    isOk: false,
    error:null,
    errorMessage:'',
    etiquetas:'',
    estados:'',    
    categorias:'',
    totalCategorias:'',
}